/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";

const StyledTreeView = styled.div`
  display: grid;
  gap: 0.5rem;

  ${({ theme }) => theme.containerMedia.sm} {
    gap: 1rem;
  }
`;

const TreeView = ({ children, ...props }) => {
  return <StyledTreeView {...props}>{children}</StyledTreeView>;
};

export default TreeView;
